import type { Chat } from "@/features/chat/shared/types";

export const mockChats: Chat[] = [
  {
    id: "654ff48d-23f4-4e2c-8269-b7da00857735#ea1f85af-5096-4643-8254-8fc5c6f34db3",
    is_read: true,
    user: {
      username: "Test_fix_tl",
      is_subscriber: true,
      is_online: false,
      is_muted: false,
      is_blacklisted: false,
      is_certified: true
    },
    last_message: {
      id: "434c4856-b7ba-4c1e-aa66-fa3321f2562c",
      sender_id: "654ff48d-23f4-4e2c-8269-b7da00857735",
      receiver_id: "ea1f85af-5096-4643-8254-8fc5c6f34db3",
      date: "2025-11-04T17:47:01Z",
      type: "push",
      content: "jhbilb,n",
      status: "active"
    },
    chat_id: 1,
    is_enabled: true
  },
  {
    id: "654ff48d-23f4-4e2c-8269-b7da00857735#c3cc988e-ac86-4c6a-8b4f-146b4e776cf9",
    is_read: true,
    user: {
      username: "Testbug993",
      is_subscriber: true,
      is_online: false,
      is_muted: false,
      is_blacklisted: false,
      is_certified: true
    },
    last_message: {
      id: "c6207061-1e0c-4741-95a7-2130b8f84d6e",
      sender_id: "654ff48d-23f4-4e2c-8269-b7da00857735",
      receiver_id: "c3cc988e-ac86-4c6a-8b4f-146b4e776cf9",
      date: "2025-11-04T17:47:01Z",
      type: "push",
      content: "jhbilb,n",
      status: "active"
    },
    chat_id: 2,
    is_enabled: true,
    media_request: 64066932,
    to_deliver: 2254634
  },
  {
    id: "654ff48d-23f4-4e2c-8269-b7da00857735#96c687b8-3406-4f24-afe3-38c505e7094b",
    is_read: true,
    user: {
      username: "Aledxdeezd",
      is_subscriber: true,
      is_online: false,
      is_muted: false,
      is_blacklisted: false,
      is_certified: false
    },
    last_message: {
      id: "39ffe91f-8297-4589-9728-be9e976e2a2b",
      sender_id: "654ff48d-23f4-4e2c-8269-b7da00857735",
      receiver_id: "96c687b8-3406-4f24-afe3-38c505e7094b",
      date: "2025-11-04T17:47:01Z",
      type: "push",
      content: "jhbilb,n",
      status: "active"
    },
    chat_id: 3,
    is_enabled: true
  },
  {
    id: "654ff48d-23f4-4e2c-8269-b7da00857735#ec52f58c-89ef-4292-ac22-fb61531dc556",
    is_read: true,
    user: {
      username: "Testnotifrefacto",
      is_subscriber: true,
      is_online: false,
      is_muted: false,
      is_blacklisted: false,
      is_certified: true
    },
    last_message: {
      id: "08f5fdc3-fb89-487e-aa10-6852cd1c5f04",
      sender_id: "654ff48d-23f4-4e2c-8269-b7da00857735",
      receiver_id: "ec52f58c-89ef-4292-ac22-fb61531dc556",
      date: "2025-11-04T17:47:01Z",
      type: "push",
      content: "jhbilb,n",
      status: "active"
    },
    chat_id: 4,
    is_enabled: true
  },
  {
    id: "654ff48d-23f4-4e2c-8269-b7da00857735#91997f64-71ec-4f19-89aa-7fbc7170392c",
    is_read: true,
    user: {
      username: "Maura_fan",
      is_subscriber: true,
      is_online: false,
      is_muted: false,
      is_blacklisted: false,
      is_certified: true
    },
    last_message: {
      id: "f8a3ebcd-a34b-4709-aae6-7f5ebb33a1f9",
      sender_id: "654ff48d-23f4-4e2c-8269-b7da00857735",
      receiver_id: "91997f64-71ec-4f19-89aa-7fbc7170392c",
      date: "2025-11-04T17:47:01Z",
      type: "push",
      content: "jhbilb,n",
      status: "active"
    },
    chat_id: 5,
    is_enabled: true
  },
  {
    id: "654ff48d-23f4-4e2c-8269-b7da00857735#af9f3612-631e-4f96-9938-df9999296e1d",
    is_read: true,
    user: {
      username: "Ben",
      is_subscriber: true,
      is_online: false,
      is_muted: false,
      is_blacklisted: false,
      is_certified: false
    },
    last_message: {
      id: "fd2b6ddb-c727-486d-aa74-f6f89857f929",
      sender_id: "654ff48d-23f4-4e2c-8269-b7da00857735",
      receiver_id: "af9f3612-631e-4f96-9938-df9999296e1d",
      date: "2025-11-04T17:47:01Z",
      type: "push",
      content: "jhbilb,n",
      status: "active"
    },
    chat_id: 6,
    is_enabled: true
  },
  {
    id: "654ff48d-23f4-4e2c-8269-b7da00857735#a7b8c9d0-e1f2-3456-7890-abcd1234ef56",
    is_read: false,
    user: {
      username: "Sophie_Durand",
      is_subscriber: false,
      is_online: true,
      is_muted: false,
      is_blacklisted: false,
      is_certified: true
    },
    last_message: {
      id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
      sender_id: "a7b8c9d0-e1f2-3456-7890-abcd1234ef56",
      receiver_id: "654ff48d-23f4-4e2c-8269-b7da00857735",
      date: new Date(Date.now() - 900000).toISOString(),
      type: "text",
      content: "Hi there!",
      status: "active"
    },
    chat_id: 7,
    is_enabled: true
  },
  {
    id: "654ff48d-23f4-4e2c-8269-b7da00857735#b8c9d0e1-f2a3-4567-8901-bcde2345f678",
    is_read: true,
    user: {
      username: "Antoine_Bernard",
      is_subscriber: true,
      is_online: false,
      is_muted: false,
      is_blacklisted: false,
      is_certified: true
    },
    last_message: {
      id: "b2c3d4e5-f6a7-8901-bcde-f12345678901",
      sender_id: "654ff48d-23f4-4e2c-8269-b7da00857735",
      receiver_id: "b8c9d0e1-f2a3-4567-8901-bcde2345f678",
      date: new Date(Date.now() - 86400000).toISOString(),
      type: "push",
      content: "Thanks for your support!",
      status: "active"
    },
    chat_id: 8,
    is_enabled: true,
    media_request: 19822047,
    to_deliver: 54911896.68480554
  },
  {
    id: "654ff48d-23f4-4e2c-8269-b7da00857735#c9d0e1f2-a3b4-5678-9012-cdef3456a789",
    is_read: false,
    user: {
      username: "Marie_Petit",
      is_subscriber: false,
      is_online: false,
      is_muted: true,
      is_blacklisted: false,
      is_certified: false
    },
    last_message: {
      id: "c3d4e5f6-a7b8-9012-cdef-123456789012",
      sender_id: "c9d0e1f2-a3b4-5678-9012-cdef3456a789",
      receiver_id: "654ff48d-23f4-4e2c-8269-b7da00857735",
      date: new Date(Date.now() - 172800000).toISOString(),
      type: "text",
      content: "Could you check my request?",
      status: "active"
    },
    chat_id: 9,
    is_enabled: true
  },
  {
    id: "654ff48d-23f4-4e2c-8269-b7da00857735#d0e1f2a3-b4c5-6789-0123-def4567b890",
    is_read: true,
    user: {
      username: "Thomas_Leroy",
      is_subscriber: true,
      is_online: false,
      is_muted: false,
      is_blacklisted: true,
      is_certified: false
    },
    last_message: {
      id: "d4e5f6a7-b8c9-0123-def4-234567890123",
      sender_id: "654ff48d-23f4-4e2c-8269-b7da00857735",
      receiver_id: "d0e1f2a3-b4c5-6789-0123-def4567b890",
      date: new Date(Date.now() - 259200000).toISOString(),
      type: "push",
      content: "Message sent",
      status: "active"
    },
    chat_id: 10,
    is_enabled: false
  }
];
